
import Task from '@/classes/task/Task';
import { TaskResponse } from '@/classes/task/types';
import { HttpMethod } from '@/types/HttpMethods';
import { talendCommon } from '@/utils/config';

class CommonController {
  public static async uploadFileToS3(file: any, bucket: string, filename: string, appendTimestamp = true): Promise<TaskResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${talendCommon.uploadFileToS3}?filename=${filename}&bucket=${bucket}&appendTimestamp=${appendTimestamp ? 'true' : 'false'}`;
    const result = await Task.execute({
      url,
      method: HttpMethod.POST,
      body: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result;
  }
}

export default CommonController;
